export default __webpack_public_path__ + "static/media/merguez.561e5dc5.jpg";